import { useState } from 'react';
import { View } from 'react-native';
import theme from '../../../theme';
import Nav from '../Nav';
import AgentsPrivacyArticle from './AgentsPrivacyArticle';
import { Footer } from '../Footer';

const AgentsPrivacy = (props) => {

    return (
        <View style={{ width: '100%', backgroundColor: theme.colors.surfacePage }}>

            <Nav/>
            <Section style={{ borderBottomWidth: 1, borderBottomColor: theme.colors.borderDefault }} />

            <AgentsPrivacyArticle/>

            <Footer/>

        </View>
    )

}

const Section = ({ style, children }) => (
  <View style={[{ width: '100%' }, style]}>{children}</View>
);

export default AgentsPrivacy